import script from "./Visitor2ServiceProviderSignUpDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./Visitor2ServiceProviderSignUpDialog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__